import { useState } from 'react';

export default function FloatingQR() {
  const [showLanguageModal, setShowLanguageModal] = useState(false);

  const handleWhatsAppRedirect = (language: 'es' | 'en') => {
    const phoneNumber = language === 'es' ? '16786931234' : '14705408595';
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
    setShowLanguageModal(false);
  };

  return (
    <>
      {/* Botón flotante */}
      <button
        onClick={() => setShowLanguageModal(true)}
        className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-gradient-to-br from-orange-600 to-orange-700 text-white rounded-full shadow-2xl hover:scale-110 transition-all flex items-center justify-center cursor-pointer group"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
        <span className="absolute right-20 bg-gray-900 text-white px-3 py-2 rounded-lg text-xs font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Contáctanos
        </span>
      </button>

      {/* Modal de selección de idioma con QR separados */}
      {showLanguageModal && (
        <div 
          className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4"
          onClick={() => setShowLanguageModal(false)}
        >
          <div className="w-full max-w-7xl flex items-center justify-around px-4">
            {/* QR Español - Extremo izquierdo */}
            <div className="flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
              <img
                src="https://static.readdy.ai/image/d57f52ecca312558916e136936375c65/3a42124519c613b7222116dc9a9ac3d9.jpeg"
                alt="QR WhatsApp Español"
                className="w-80 h-80 md:w-96 md:h-96 lg:w-[450px] lg:h-[450px] cursor-pointer hover:scale-105 transition-transform"
                onClick={() => handleWhatsAppRedirect('es')}
              />
              <div className="mt-6 text-center">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <i className="ri-translate text-white text-2xl"></i>
                  <p className="text-2xl font-bold text-white">Español</p>
                </div>
                <p className="text-xl text-white font-medium">678 693 1234</p>
              </div>
            </div>

            {/* QR English - Extremo derecho */}
            <div className="flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
              <img
                src="https://static.readdy.ai/image/d57f52ecca312558916e136936375c65/4d4ca390699d10b6288b27f736af1999.jpeg"
                alt="QR WhatsApp English"
                className="w-80 h-80 md:w-96 md:h-96 lg:w-[450px] lg:h-[450px] cursor-pointer hover:scale-105 transition-transform"
                onClick={() => handleWhatsAppRedirect('en')}
              />
              <div className="mt-6 text-center">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <i className="ri-global-line text-white text-2xl"></i>
                  <p className="text-2xl font-bold text-white">English</p>
                </div>
                <p className="text-xl text-white font-medium">470 540 8595</p>
              </div>
            </div>
          </div>

          {/* Botón cerrar */}
          <button
            onClick={() => setShowLanguageModal(false)}
            className="absolute top-8 right-8 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center cursor-pointer transition-all"
          >
            <i className="ri-close-line text-3xl text-white"></i>
          </button>
        </div>
      )}
    </>
  );
}
